function hasSufficientCredits(
  credits: number,
  creditsToDeduct: number,
): boolean {
  return credits >= creditsToDeduct;
}

export default hasSufficientCredits;
